export const API_PATH_ApiTrafficStudyPost = '/services/traffic-studies/apiTrafficStudyPost';
